
import * as React from 'react'
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';
import {Message} from '../Components/Message';
import {browserHistory} from 'react-router';
import {CloseX} from '../Components/CloseX';
import {connect} from 'react-redux';
import {ScreenDoor} from '../Components/ScreenDoor';


const btn : CSSProperties = {
    border: "1px solid transparent",
    backgroundColor: "#B4B5B4",
    height: '40px',
    lineHeight: '40px',
    fontSize: '15px',
    padding: '0px 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '25px auto',
    width: '200px',
    fontFamily: 'BarlowMedium'
}

const hdr: CSSProperties = {
    textAlign: 'center',
    fontFamily: 'BarlowMedium',
    color: 'white',
    fontSize:'20px',
    marginBottom:'15px'
}
const how: CSSProperties = {
    fontFamily: 'BarlowMedium',
    color: 'white',
    fontSize:'16px'
}
const style: CSSProperties = {
    border:'1px solid rgb(166, 166, 166)',
    fontFamily:"BarlowMedium",
    color: 'black',
    fontStyle:'italic',
    width:'350px',
    marginBottom:'15px'
}
const errStyle: CSSProperties = {
    color:'red',
    textAlign:'center',
    fontSize:'15px'
}
const formDiv: React.CSSProperties = {
    width:'75%',
    padding:'20px',
    textAlign:'center',
    color:'white'

}
const btnDiv: React.CSSProperties = {
    display:'flex',
    alignItems:'center'
}
const leadDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    backgroundColor:'3A54B4'
}
const select: React.CSSProperties = {
    width:'350px',
    height:'22px',
    color:'black'

}
const option: React.CSSProperties = {
    fontFamily:"BarlowMedium",
    color:'black'
}
const selectDiv: React.CSSProperties = {
    textAlign:'left'
}
const leadCont: React.CSSProperties = {
    width:'50%',
    backgroundColor:'#5E6A74',
    display:'flex',
    justifyContent:'center'
}
class LeadProps extends Tgcc.BaseProps{
    lead:boolean ;
}

class _RealCampusLeadForm extends React.Component<LeadProps,any> {
    state = {
        name:null,
        email:null,
        school:null,
        source:null,
        finished:false,
        error:'',
        isWaiting: false,
        didPopUp: true
    }
    handleNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({name:evt.currentTarget.value});
    }
    handleEmailChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({email:evt.currentTarget.value});
    }
    handleSchoolChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({school:evt.currentTarget.value});
    }
    handleSourceChange = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({source:evt.currentTarget.value});
    }
    sendLead = () => {       
        if(!this.state.name){
            this.setState({error:"Please provide your name."})
        } else if(!this.state.email){
            this.setState({error:"Please provide your email address."})
        }
        else {
            this.setState({isWaiting:true});
            var lead = new Tgcc.Lead
            lead.name = this.state.name;
            lead.email = this.state.email;
            lead.school = this.state.school;
            lead.source = this.state.source;
            lead.timestamp = new Date().toLocaleString();
            Request.sendLead(lead,this.finished)
            this.props.dispatch({type: Tgcc.StateAction.Lead, payload: true});
        }
    }
    finished = () => {
        this.setState({finished:true});
    }
    whenFinished = () => {
        browserHistory.push(Tgcc.Routes.Campus);
    }
    getThankYou = () => {
        return <Message 
            Title="We will be in touch!"         
            UseTitleScript={true}
            Message1="Thanks for signing up!"
            onContinue={this.cancel}
        />

    }
    cancel = () => {
        this.setState({didPopUp:false});
        this.setState({finished:false});
        this.setState({isWaiting:false});
        this.props.dispatch({type: Tgcc.StateAction.Lead, payload: true});
        window.location.reload()
    }
    getLeadForm(){
            var waiting = this.state.isWaiting ? Tgcc.workingGif: <div style={btnDiv} onClick={this.sendLead}><div style={btn} className="leadShipBtn">Get Free Shipping</div></div>
               return (
                <div style={formDiv} className="leadForm">
                <div style={hdr}>Join our E-Mail  List & Get FREE Bulk Shipping on your first order! Offer applies only to the T-Shirt Organizer, not individual orders. Be the first to know about new arrivals, special events, and more.</div>
                <div style={errStyle}>{this.state.error}</div>
                <div style={leadDiv}>
                    <input style={style} className="leadFormInp" type="text" name="name" placeholder="Name" onChange={this.handleNameChange}/>
                    <input style={style} className="leadFormInp" type="text" name="email" placeholder="Email" onChange={this.handleEmailChange}/>
                    <input style={style} className="leadFormInp" type="text" name="school" placeholder="School & Organization" onChange={this.handleSchoolChange}/>
                    <div style={selectDiv}>
                        <div style={how}>How'd you hear about us?</div>
                        <select name="source" className="leadFormInp" style={select} onChange={this.handleSourceChange}>
                            <option style={option}  value="None"></option>
                            <option style={option}  value="Pinterest">Pinterest</option>
                            <option style={option}  value="Instagram">Instagram</option>
                            <option style={option}  value="From a Friend">From a Friend</option>
                            <option style={option}  value="Email">Email</option>
                            <option style={option}  value="internet">Internet</option>
                        </select>
                    </div>
                    {waiting}
                </div>
                  </div>
            )
    }

    render () {
        var thankYou = this.state.finished ? this.getThankYou() : null;

        return (
            <div style={leadCont} className="leadCont">
                {this.getLeadForm()}
                {thankYou}
            </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState,lead:any) => {
    return { 
        lead: state.didLead,
    };
    
};
export var RealCampusLeadForm = connect(mapStateToProps)(_RealCampusLeadForm);